import * as i0 from '@angular/core';
import { Component, Directive, ViewEncapsulation, ChangeDetectionStrategy, Input, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/material/icon';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i2$1 from '@xpo-ltl/ngx-ltl-core/utils';
import { XpoUtilsModule } from '@xpo-ltl/ngx-ltl-core/utils';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import * as i1$1 from '@angular/router';
import { NavigationEnd } from '@angular/router';

const _c0$2 = ["xpo-header", ""];
const _c1$2 = [[["xpo-header-hamburger"]], [["xpo-app-switcher-popover"]], [["xpo-application-switcher"]], [["xpo-header-app-name"]], [["xpo-header-sub-app-name"]], [["xpo-header-navigation"]], [["xpo-header-items"]], [["xpo-header-actions"]], [["xpo-header-utilities-actions"]]];
const _c2$1 = ["xpo-header-hamburger", "xpo-app-switcher-popover", "xpo-application-switcher", "xpo-header-app-name", "xpo-header-sub-app-name", "xpo-header-navigation", "xpo-header-items", "xpo-header-actions", "xpo-header-utilities-actions"];
class XpoHeaderHamburger {
}
XpoHeaderHamburger.ɵfac = function XpoHeaderHamburger_Factory(t) { return new (t || XpoHeaderHamburger)(); };
XpoHeaderHamburger.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoHeaderHamburger, selectors: [["xpo-header-hamburger"]], hostAttrs: [1, "xpo-Header-hamburger"], decls: 2, vars: 0, template: function XpoHeaderHamburger_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-icon");
        i0.ɵɵtext(1, "menu");
        i0.ɵɵelementEnd();
    } }, directives: [i1.MatIcon], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoHeaderHamburger, [{
        type: Component,
        args: [{
                selector: 'xpo-header-hamburger',
                host: { class: 'xpo-Header-hamburger' },
                template: `
    <mat-icon>menu</mat-icon>
  `,
            }]
    }], null, null); })();
class XpoHeaderAppName {
    constructor(host) {
        this.host = host;
    }
    /**
     * The application name renderer by content projection
     */
    get appName() {
        // TODO: evaluate if the projected content it is not only text
        return this.host.nativeElement.textContent;
    }
}
XpoHeaderAppName.ɵfac = function XpoHeaderAppName_Factory(t) { return new (t || XpoHeaderAppName)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
XpoHeaderAppName.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoHeaderAppName, selectors: [["xpo-header-app-name"]], hostAttrs: [1, "xpo-Header-appName"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoHeaderAppName, [{
        type: Directive,
        args: [{
                selector: 'xpo-header-app-name',
                host: { class: 'xpo-Header-appName' },
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, null); })();
class XpoHeaderSubAppName {
    constructor(host) {
        this.host = host;
    }
    /**
     * The application sub-name renderer by content projection
     */
    get appSubName() {
        // TODO: evaluate if the projected content it is not only text
        return this.host.nativeElement.textContent;
    }
}
XpoHeaderSubAppName.ɵfac = function XpoHeaderSubAppName_Factory(t) { return new (t || XpoHeaderSubAppName)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
XpoHeaderSubAppName.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoHeaderSubAppName, selectors: [["xpo-header-sub-app-name"]], hostAttrs: [1, "xpo-Header-subAppName"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoHeaderSubAppName, [{
        type: Directive,
        args: [{
                selector: 'xpo-header-sub-app-name',
                host: { class: 'xpo-Header-subAppName' },
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, null); })();
class XpoHeaderItems {
}
XpoHeaderItems.ɵfac = function XpoHeaderItems_Factory(t) { return new (t || XpoHeaderItems)(); };
XpoHeaderItems.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoHeaderItems, selectors: [["xpo-header-items"]], hostAttrs: [1, "xpo-Header-items"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoHeaderItems, [{
        type: Directive,
        args: [{
                selector: 'xpo-header-items',
                host: { class: 'xpo-Header-items' },
            }]
    }], null, null); })();
class XpoHeaderActions {
}
XpoHeaderActions.ɵfac = function XpoHeaderActions_Factory(t) { return new (t || XpoHeaderActions)(); };
XpoHeaderActions.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoHeaderActions, selectors: [["xpo-header-actions"]], hostAttrs: [1, "xpo-Header-actions"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoHeaderActions, [{
        type: Directive,
        args: [{
                selector: 'xpo-header-actions',
                host: { class: 'xpo-Header-actions' },
            }]
    }], null, null); })();
class XpoHeaderUtilitiesActions {
}
XpoHeaderUtilitiesActions.ɵfac = function XpoHeaderUtilitiesActions_Factory(t) { return new (t || XpoHeaderUtilitiesActions)(); };
XpoHeaderUtilitiesActions.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoHeaderUtilitiesActions, selectors: [["xpo-header-utilities-actions"]], hostAttrs: [1, "xpo-Header-utilities-actions"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoHeaderUtilitiesActions, [{
        type: Directive,
        args: [{
                selector: 'xpo-header-utilities-actions',
                host: { class: 'xpo-Header-utilities-actions' },
            }]
    }], null, null); })();
class XpoHeader {
}
XpoHeader.ɵfac = function XpoHeader_Factory(t) { return new (t || XpoHeader)(); };
XpoHeader.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoHeader, selectors: [["", "xpo-header", ""]], hostAttrs: [1, "xpo-Header"], attrs: _c0$2, ngContentSelectors: _c2$1, decls: 11, vars: 0, consts: [[1, "xpo-Header-section", "xpo-Header-section--dynamic"], [1, "xpo-Header-section"]], template: function XpoHeader_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c1$2);
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵprojection(2, 1);
        i0.ɵɵprojection(3, 2);
        i0.ɵɵprojection(4, 3);
        i0.ɵɵprojection(5, 4);
        i0.ɵɵprojection(6, 5);
        i0.ɵɵprojection(7, 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 1);
        i0.ɵɵprojection(9, 7);
        i0.ɵɵprojection(10, 8);
        i0.ɵɵelementEnd();
    } }, styles: ["@charset \"UTF-8\";.flex--stretch{flex:1}.xpo-Header{display:flex;height:40px;justify-content:space-between;width:100%}.xpo-Header .xpo-Header-section:last-of-type{padding-right:8px}.xpo-Header-account-actionLink{display:inline-flex}.xpo-Header-menu-arrowIcon{font-size:36px;line-height:1.571rem}.xpo-Header-section{align-items:center;display:flex}.xpo-Header-section--dynamic{flex:1 1 auto}.xpo-Header-section .mat-tab-group .mat-tab-nav-bar,.xpo-Header-section .mat-tab-group .mat-tab-header{border:none}.xpo-Header-section .mat-tab-group .mat-tab-label{color:#333;font-size:1.143rem;margin-right:20px}.xpo-Header-section .mat-tab-group .mat-tab-label:first-of-type{margin-left:20px}.xpo-Header-section .mat-tab-group .mat-tab-label-active{color:#000}.xpo-Header-section .mat-tab-group .mat-ink-bar{background-color:#c00;height:4px}.xpo-Header-section .xpo-AppSwitcherPopover-trigger{color:#4a4a4a;margin-left:8px}.xpo-Header-section .xpo-Header-navigation-dynamic-subMenu-button{background-color:transparent;border:none;border-bottom:4px solid transparent;border-radius:0;color:#333;line-height:32px;padding:1px 8px;display:inline-flex;align-items:center}.xpo-Header-section .xpo-Header-navigation-dynamic-subMenu-button:hover,.xpo-Header-section .xpo-Header-navigation-dynamic-subMenu-button:focus,.xpo-Header-section .xpo-Header-navigation-dynamic-subMenu-button:active{background-color:transparent;color:#000}.xpo-Header-hamburger{align-items:center;cursor:pointer;display:flex;height:100%;margin-left:8px;transition:color ease-in-out .1s}.xpo-Header-hamburger:hover,.xpo-Header-hamburger:focus{color:#9b9b9b}.xpo-Header-appName,.xpo-Header-hamburger{color:#43494d}.xpo-Header-appName,.xpo-Header-subAppName{font-size:1.428rem;font-weight:500;letter-spacing:.38px;line-height:1.286;font-weight:900}.xpo-Header-appName{margin-left:8px}.xpo-Header-subAppName{border-right:1px solid #d8d8d8;color:#858585;flex:0 0 auto;padding-right:24px}.xpo-Header-subAppName:before{content:\"\\a0\"}.xpo-Header-items{align-items:center;display:inline-flex}.xpo-Header-items:before{background-color:#6f6f6f;content:\" \";display:inline-block;height:1.428rem;margin:0 16px;width:1px}.xpo-Header-items button a{color:inherit}.xpo-Header-actions{align-items:center;display:flex}.xpo-Header-actions .xpo-BadgeDot--important{margin-right:0!important}.xpo-Header-actions>*{margin-left:12px}.xpo-Header-actions>*:first-child{margin-left:0}.xpo-Header-actions>*:last-child{margin-left:8px}.xpo-Header-utilities-actions{align-items:center;display:flex}.xpo-Header-utilities-actions .mat-icon{align-items:center;color:#4a4a4a;cursor:pointer;display:flex;height:40px;width:40px}.xpo-Header-utilities-actions>*{align-items:center;border-left:1px solid #d8d8d8;display:flex;height:40px;width:40px}.xpo-Header-utilities-actions>.mat-icon{justify-content:center}.xpo-Header-actions-search .mat-icon{color:#424242;font-size:1.285rem;font-weight:400;left:30px;position:relative;top:5px}.xpo-Header-actions-search input::placeholder{color:#424242}.xpo-Header-actions-search input{border:1px solid #dddddd;font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;font-size:1rem;font-style:normal;height:30px;letter-spacing:normal;padding:4px 8px 4px 30px;text-align:left;text-transform:none;width:150px}@media only screen and (max-width: 480px){.xpo-Header-utilities-actions,.xpo-AppSwitcherPopover{display:none}}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoHeader, [{
        type: Component,
        args: [{
                selector: '[xpo-header]',
                templateUrl: './header.component.html',
                styleUrls: ['./header.component.scss'],
                host: {
                    class: 'xpo-Header',
                },
                encapsulation: ViewEncapsulation.None,
            }]
    }], null, null); })();

// Just defined to allow user to use the selector in their HTML
class XpoHeaderSubMenuDirective {
}
XpoHeaderSubMenuDirective.ɵfac = function XpoHeaderSubMenuDirective_Factory(t) { return new (t || XpoHeaderSubMenuDirective)(); };
XpoHeaderSubMenuDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoHeaderSubMenuDirective, selectors: [["xpo-header-navigation-sub-menu"]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoHeaderSubMenuDirective, [{
        type: Directive,
        args: [{
                selector: 'xpo-header-navigation-sub-menu',
            }]
    }], null, null); })();

// Search bar container
class XpoHeaderActionsSearch {
}
XpoHeaderActionsSearch.ɵfac = function XpoHeaderActionsSearch_Factory(t) { return new (t || XpoHeaderActionsSearch)(); };
XpoHeaderActionsSearch.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoHeaderActionsSearch, selectors: [["xpo-header-actions-search"], ["xpoHeaderActionsSearch"]], hostAttrs: [1, "xpo-Header-actions-search"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoHeaderActionsSearch, [{
        type: Directive,
        args: [{
                selector: 'xpo-header-actions-search, xpoHeaderActionsSearch ',
                host: {
                    class: 'xpo-Header-actions-search',
                },
            }]
    }], null, null); })();

const _c0$1 = ["menuTrigger"];
const _c1$1 = ["projectedWrapper"];
function XpoHeaderNavigationDynSubMenuComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5, 6);
    i0.ɵɵlistener("click", function XpoHeaderNavigationDynSubMenuComponent_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.toggleMenu(); });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-icon", 7);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵclassProp("xpo-selected", ctx_r0.underlineButton);
    i0.ɵɵproperty("matMenuTriggerFor", _r1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.menuTitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.menuIcon);
} }
function XpoHeaderNavigationDynSubMenuComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function XpoHeaderNavigationDynSubMenuComponent_button_4_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const btn_r7 = restoredCtx.$implicit; return btn_r7.click(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r7 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", btn_r7.innerText, " ");
} }
const _c2 = ["*"];
class XpoHeaderNavigationDynSubMenuComponent {
    constructor(cd, router) {
        this.cd = cd;
        this.router = router;
        this.ARROW_DROP_DOWN = 'arrow_drop_down';
        this.ARROW_DROP_UP = 'arrow_drop_up';
        // Projected buttons coming from implementation
        this.projectedButtons = [];
        this.menuIcon = this.ARROW_DROP_DOWN;
        this.isMenuOpened = false;
        this.underlineButton = false;
        // If showMenu=false hide the dropdown button
        this.showMenu = false;
        // Dynamic buttons coming from the lib when window is resized and buttons should be hidden
        this.dynButtons = [];
        this.updateButton$ = new Subject();
        this.menuTitle = 'Sub Menu';
    }
    ngOnInit() {
        // Creating the update button as an observable improving performance
        // with a debounce avoiding multiple and unnecessary calls to the update process
        this.updateButtonSubscription = this.updateButton$
            .pipe(debounceTime(100))
            .subscribe((dynButtons) => this.updateButton(dynButtons));
    }
    ngAfterViewInit() {
        // We can't use a @ContentChild to get the buttons in a proper way because they are
        // projected and encapsulated in a <ng-content></ng-content>
        // Getting projected buttons from the wrapper. If no one is projected return empty array
        this.projectedButtons = this.projectedWrapper.nativeElement.getElementsByTagName('button') || [];
        this.updateButton$.next();
    }
    // Public method called from parent when the navbar is resized
    tryToCloseMenu() {
        if (this.menuTrigger) {
            this.menuTrigger.closeMenu();
        }
    }
    // Public method called from html
    // We can't use the material open() method due a limitation of them.
    // Our button that triggers the open/close sometimes isn't rendered.
    // They didn't provide it in the same way than the onMenuClose so
    // he have to connect with the menuTrigger API and it has a delay with the
    // ngAfterViewInit cycle.
    // Summary: This toggleMenu is called from a (click) in the button
    toggleMenu() {
        this.isMenuOpened = !this.isMenuOpened;
        if (this.isMenuOpened) {
            this.menuIcon = this.ARROW_DROP_UP;
        }
        this.updateButton$.next();
    }
    // Public method called from html
    onMenuClose() {
        this.menuIcon = this.ARROW_DROP_DOWN;
        this.isMenuOpened = false;
        this.updateButton$.next();
    }
    // We update the buttons showed in the list and underline it if is active
    updateButton(incomingDynButtons) {
        // If no dynButtons are coming in parameters, left the current this.dynButtons
        this.dynButtons = incomingDynButtons || this.dynButtons;
        this.showMenu = this.projectedButtons.length > 0 || this.dynButtons.length > 0;
        this.underlineButton = this.isMenuOpened || this.isSomeChildButtonActive();
        this.cd.detectChanges();
    }
    isSomeChildButtonActive() {
        // We iterate each projected and dynamic button comparing its routerLink with the
        // current url to know if it's the routerActiveLink and we should underline the
        // external button
        return [...this.projectedButtons, ...this.dynButtons]
            .some((button) => {
            var _a;
            // If routerLink attr doesn't exists the getNamedItem(..).value returns undefined so nothing is going to be broken
            const routerLink = (_a = button.attributes.getNamedItem('routerLink')) === null || _a === void 0 ? void 0 : _a.value;
            return this.router.url.includes(routerLink);
        });
    }
    ngOnDestroy() {
        if (this.updateButtonSubscription) {
            this.updateButtonSubscription.unsubscribe();
        }
    }
}
XpoHeaderNavigationDynSubMenuComponent.ɵfac = function XpoHeaderNavigationDynSubMenuComponent_Factory(t) { return new (t || XpoHeaderNavigationDynSubMenuComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.Router)); };
XpoHeaderNavigationDynSubMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoHeaderNavigationDynSubMenuComponent, selectors: [["xpo-header-navigation-dyn-sub-menu"]], viewQuery: function XpoHeaderNavigationDynSubMenuComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1, 5);
        i0.ɵɵviewQuery(_c1$1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuTrigger = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.projectedWrapper = _t.first);
    } }, inputs: { menuTitle: "menuTitle" }, ngContentSelectors: _c2, decls: 8, vars: 2, consts: [["class", "xpo-Header-navigation-dynamic-subMenu-button", "xpoDynamicMenuBlock", "", 3, "xpo-selected", "matMenuTriggerFor", "click", 4, "ngIf"], [1, "xpo-Header-navigation-dynamic-subMenu", 3, "closed"], ["myStandardMenu", "matMenu"], [3, "click", 4, "ngFor", "ngForOf"], ["projectedWrapper", ""], ["xpoDynamicMenuBlock", "", 1, "xpo-Header-navigation-dynamic-subMenu-button", 3, "matMenuTriggerFor", "click"], ["menuTrigger", "matMenuTrigger"], [1, "xpo-Header-menu-arrowIcon"], [3, "click"]], template: function XpoHeaderNavigationDynSubMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, XpoHeaderNavigationDynSubMenuComponent_button_0_Template, 6, 5, "button", 0);
        i0.ɵɵelementStart(1, "mat-menu", 1, 2);
        i0.ɵɵlistener("closed", function XpoHeaderNavigationDynSubMenuComponent_Template_mat_menu_closed_1_listener() { return ctx.onMenuClose(); });
        i0.ɵɵelementStart(3, "div");
        i0.ɵɵtemplate(4, XpoHeaderNavigationDynSubMenuComponent_button_4_Template, 2, 1, "button", 3);
        i0.ɵɵelementStart(5, "div", null, 4);
        i0.ɵɵprojection(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showMenu);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.dynButtons);
    } }, directives: [i2.NgIf, i3.MatMenu, i2.NgForOf, i2$1.XpoDynamicMenuBlockDirective, i3.MatMenuTrigger, i1.MatIcon], styles: [".flex--stretch{flex:1}.xpo-Header-navigation-dynamic-subMenu.mat-menu-panel{border-top:1px solid #d8d8d8;box-shadow:1px 4px 6px #bdbdbd;margin-top:0}.xpo-Header-navigation-dynamic-subMenu .mat-menu-content div{display:flex;flex-direction:column;min-width:250px}.xpo-Header-navigation-dynamic-subMenu .mat-menu-content div>*{display:flex;flex-direction:column}.xpo-Header-navigation-dynamic-subMenu .mat-menu-content div button{background-color:#fff;border:0;box-sizing:content-box;color:#333;cursor:pointer;font-family:inherit;font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;font-size:1.143rem;line-height:1.857rem;padding:6px;text-align:left}.xpo-Header-navigation-dynamic-subMenu .mat-menu-content div button:hover{background:#e4effa;color:#000}.xpo-Header-navigation-dynamic-subMenu .mat-menu-content div button:focus{outline:none}.xpo-Header-navigation-dynamic-subMenu .mat-menu-content div button:disabled{opacity:unset}.xpo-Header-navigation-dynamic-subMenu .mat-menu-content div button:last-of-type{border-bottom:none}.xpo-Header-navigation-dynamic-subMenu .mat-menu-content div .xpo-selected{background:#e4effa;color:#000;font-weight:500}.xpo-Header-navigation-dynamic-subMenu .mat-menu-content div .mat-icon{display:none}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoHeaderNavigationDynSubMenuComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-header-navigation-dyn-sub-menu',
                templateUrl: 'header-navigation-sub-menu.component.html',
                styleUrls: ['header-navigation-sub-menu.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1$1.Router }]; }, { menuTitle: [{
            type: Input
        }], menuTrigger: [{
            type: ViewChild,
            args: ['menuTrigger', { static: false }]
        }], projectedWrapper: [{
            type: ViewChild,
            args: ['projectedWrapper']
        }] }); })();

const _c0 = ["*", [["xpo-header-navigation-sub-menu"]]];
const _c1 = ["*", "xpo-header-navigation-sub-menu"];
class XpoHeaderNavigationComponent {
    constructor(router) {
        this.router = router;
        this.menuTitle = 'Sub Menu';
    }
    ngOnInit() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // Update sub menu every time the navigation change
                this.subMenuWrapper.updateButton$.next();
            }
        });
    }
    // Called when the navbar is resized. Receives the hidden buttons if correspond
    updateButtonsVisibility(hiddenButtons) {
        // Close the dropdown menu due the navbar is being resized
        this.subMenuWrapper.tryToCloseMenu();
        // Send the hidden buttons to the submenu. If no one is hidden it sends and empty array
        this.subMenuWrapper.updateButton$.next(hiddenButtons);
    }
}
XpoHeaderNavigationComponent.ɵfac = function XpoHeaderNavigationComponent_Factory(t) { return new (t || XpoHeaderNavigationComponent)(i0.ɵɵdirectiveInject(i1$1.Router)); };
XpoHeaderNavigationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoHeaderNavigationComponent, selectors: [["xpo-header-navigation"]], viewQuery: function XpoHeaderNavigationComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(XpoHeaderNavigationDynSubMenuComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.subMenuWrapper = _t.first);
    } }, hostAttrs: [1, "xpo-header-navigation"], inputs: { menuTitle: "menuTitle" }, ngContentSelectors: _c1, decls: 4, vars: 3, consts: [["xpoDynamicMenu", "", 3, "hiddenBtnEvent"], ["xpoDynamicMenuBlock", "", 3, "menuTitle"]], template: function XpoHeaderNavigationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0);
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("hiddenBtnEvent", function XpoHeaderNavigationComponent_Template_div_hiddenBtnEvent_0_listener($event) { return ctx.updateButtonsVisibility($event); });
        i0.ɵɵprojection(1);
        i0.ɵɵelementStart(2, "xpo-header-navigation-dyn-sub-menu", 1);
        i0.ɵɵprojection(3, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassProp("xpo-header-navigation--menu-opened", ctx.subMenuWrapper == null ? null : ctx.subMenuWrapper.isMenuOpened);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("menuTitle", ctx.menuTitle);
    } }, directives: [i2$1.XpoDynamicMenuDirective, XpoHeaderNavigationDynSubMenuComponent, i2$1.XpoDynamicMenuBlockDirective], styles: [".flex--stretch{flex:1}.xpo-header-navigation{flex:1 1 auto}.xpo-header-navigation .xpo-header-navigation--menu-opened button:not(.xpo-Header-navigation-dynamic-subMenu-button){border-bottom:4px solid transparent}.xpo-header-navigation .xpo-header-navigation--menu-opened button.xpo-Header-navigation-dynamic-subMenu-button{text-shadow:none}.xpo-header-navigation button{background-color:#fff;border:none;border-bottom:4px solid transparent;color:#333;cursor:pointer;font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;font-size:1.143rem;height:38px;margin:0 13px;padding-bottom:0}.xpo-header-navigation button:first-of-type{margin-left:18px}.xpo-header-navigation button.xpo-selected{border-bottom:4px solid #cc0000;text-shadow:0 0 .5px #000000}.xpo-header-navigation button:focus{outline:transparent}.xpo-header-navigation button:hover,.xpo-header-navigation button:active{border-bottom:4px solid #cc0000;outline:transparent}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoHeaderNavigationComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-header-navigation',
                templateUrl: './header-navigation.component.html',
                styleUrls: ['./header-navigation.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: {
                    class: 'xpo-header-navigation',
                },
            }]
    }], function () { return [{ type: i1$1.Router }]; }, { menuTitle: [{
            type: Input
        }], subMenuWrapper: [{
            type: ViewChild,
            args: [XpoHeaderNavigationDynSubMenuComponent]
        }] }); })();

class XpoHeaderModule {
}
XpoHeaderModule.ɵfac = function XpoHeaderModule_Factory(t) { return new (t || XpoHeaderModule)(); };
XpoHeaderModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoHeaderModule });
XpoHeaderModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, MatButtonModule, XpoIconModule, MatMenuModule, XpoUtilsModule], XpoUtilsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoHeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    XpoHeader,
                    XpoHeaderActions,
                    XpoHeaderItems,
                    XpoHeaderAppName,
                    XpoHeaderHamburger,
                    XpoHeaderSubAppName,
                    XpoHeaderUtilitiesActions,
                    XpoHeaderNavigationComponent,
                    XpoHeaderNavigationDynSubMenuComponent,
                    XpoHeaderActionsSearch,
                    XpoHeaderSubMenuDirective,
                ],
                imports: [CommonModule, MatButtonModule, XpoIconModule, MatMenuModule, XpoUtilsModule],
                exports: [
                    XpoHeader,
                    XpoHeaderActions,
                    XpoHeaderItems,
                    XpoHeaderAppName,
                    XpoHeaderHamburger,
                    XpoHeaderSubAppName,
                    XpoHeaderUtilitiesActions,
                    XpoHeaderNavigationComponent,
                    XpoHeaderNavigationDynSubMenuComponent,
                    XpoHeaderActionsSearch,
                    XpoUtilsModule,
                    XpoHeaderSubMenuDirective,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoHeaderModule, { declarations: [XpoHeader,
        XpoHeaderActions,
        XpoHeaderItems,
        XpoHeaderAppName,
        XpoHeaderHamburger,
        XpoHeaderSubAppName,
        XpoHeaderUtilitiesActions,
        XpoHeaderNavigationComponent,
        XpoHeaderNavigationDynSubMenuComponent,
        XpoHeaderActionsSearch,
        XpoHeaderSubMenuDirective], imports: [CommonModule, MatButtonModule, XpoIconModule, MatMenuModule, XpoUtilsModule], exports: [XpoHeader,
        XpoHeaderActions,
        XpoHeaderItems,
        XpoHeaderAppName,
        XpoHeaderHamburger,
        XpoHeaderSubAppName,
        XpoHeaderUtilitiesActions,
        XpoHeaderNavigationComponent,
        XpoHeaderNavigationDynSubMenuComponent,
        XpoHeaderActionsSearch,
        XpoUtilsModule,
        XpoHeaderSubMenuDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoHeader, XpoHeaderActions, XpoHeaderActionsSearch, XpoHeaderAppName, XpoHeaderHamburger, XpoHeaderItems, XpoHeaderModule, XpoHeaderNavigationComponent, XpoHeaderNavigationDynSubMenuComponent, XpoHeaderSubAppName, XpoHeaderSubMenuDirective, XpoHeaderUtilitiesActions };
